<template lang="pug">
.form-group(id='dawnSelect__main-wrapper' :class='{ "invalid": error, "hidden": hidden }')
  ed-input-tooltip(v-if='helptipBody && isOpen || helptipBody && error'
                  :helptipHeader='helptipHeader'
                  :helptipBody='helptipBody'
                  :errorTip='error'
                  :class='{"error-message": error}'
                  )
  label.control-label(v-if='fieldLabel')
    | {{fieldLabel}}
    em.optional(v-if='!required && !hideOptional') &nbsp;- optional
  .dawnSelect(
    :tabindex='searchable ? -1 : tabindex'
    :class='{ "dawnSelect--active form-field--active": isOpen && !multilist, "dawnSelect--disabled": disabled, "dawnSelect--above": isAbove, "dawnSelect--over": isOver, "dawnSelect--multilist": multilist }'
    @focus='activate()'
    @blur='searchable ? false : deactivate()'
    @keydown.self.down.prevent='pointerForward()'
    @keydown.self.up.prevent='pointerBackward()'
    @keydown.enter.tab.stop.self='addPointerElement($event)'
    @keyup.esc='deactivate()'
    v-on-clickaway='deactivate'
  )
    slot(name='caret', :toggle='toggle')
      .dawnSelect__select(@mousedown.prevent.stop='toggle()')
    span.remove
      slot(name='clear', :search='search')
    .dawnSelect__tags(ref='tags')
      template(v-if='internalValue && internalValue.length > limit')
        strong.dawnSelect__strong(v-text='limitText(internalValue.length - limit)')
      transition(name='dawnSelect__loading')
        slot(name='loading')
          .dawnSelect__spinner(v-show='loading')
      small.icon-wrapper(v-if='icon')
        i.icon(:class='icon')
      input.dawnSelect__input(
        @focus='focused = true'
        @blur='focused = false'
        ref='search'
        :name='name'
        :id='id'
        type='text'
        autocomplete='off'
        :placeholder='currentOptionLabel || placeholder'
        v-bind='$props'
        v-focus.lazy='autofocus'
        :required='required'
        :autofocus='autofocus'
        v-if='searchable'
        :value='isOpen ? search : currentOptionLabel'
        :disabled='disabled'
        :tabindex='tabindex'
        @input='updateSearch($event.target.value); debounceSearching()'
        @focus.prevent='activate()'
        @blur.prevent='multilist || deactivate($event)'
        @keyup.esc='deactivate()'
        @keydown.down.prevent='pointerForward()'
        @keydown.up.prevent='pointerBackward()'
        @keydown.enter.prevent.stop.self='addPointerElement($event)'
        @keydown.delete.stop='removeLastElement()'
        @keyup="$emit('keyup', $event.target.value)"
        :readonly='isOver || multilist'
        :style='displayedValueStyle'
        :title='displayedValueTitle'
      )
      span.dawnSelect__single(
        v-if='!searchable'
        @mousedown.prevent='toggle'
        v-text='currentOptionLabel'
      )
    transition(name='dawnSelect')
      .dawnSelect__header-wrapper(v-if='!!multilist' v-show='isOpen', :class='{ empty: !options.length }')
        label(v-show='options[0] && options[0][groupValues]') {{ placeholder }}
        ed-select.inline.small(v-show='options.length > 1'
                               :options='options'
                               v-model='selectedGroup'
                               :label='groupLabel'
                               @select='selectGroup'
                               open-direction='over'
                               id='groupController'
        )
        div(:class='{ "header-wrapper": $slots.additionalOptions }')
          slot(name='additionalOptions' v-show='isOpen')
        ed-input.list-search(:placeholder='$t("Search")'
                  search
                  :value='search'
                  @input='updateSearch'
        )
    transition(name='dawnSelect')
      .dawnSelect__content-wrapper.list.multilist(:style='{ maxHeight: optimizedHeight + "px" }'
                                   :class='{ empty: !options.length }'
                                   v-show='isOpen'
                                   @focus='activate'
                                   @mousedown.prevent
                                  :name='name + "__content-wrapper"'
                                   ref='list'
                                   :endpoint='$attrs.openEndpoint'
      )
        ul.dawnSelect__content(:style='contentStyle')
          div(:class='{ "header-wrapper": $slots.beforeList }')
            slot(name='beforeList')
          li(v-if='multiple && max === internalValue.length')
            span.dawnSelect__option
              slot(name='maxElements') Maximum of {{ max }} options selected. First remove a selected option to select another.
          template(v-if='!max || internalValue.length < max')
            li.dawnSelect__element(v-for='(option, index) of filteredOptions' :key='index')
              span.dawnSelect__option(
                v-if='!(option && (option.$isLabel || option.$isDisabled))'
                :class='optionHighlight(index, option)'
                @click.stop='select(option, index)'
                @mouseenter.self='pointerSet(index)'
                :data-select='option && option.isTag ? tagPlaceholder : selectLabelText'
                :data-selected='selectedLabelText'
                :data-deselect='deselectLabelText'
                ref='options'
                v-tooltip.bottom='optionTooltip(option, index)'
              )
                checkbox(v-if='multiple && checkboxes' :option-status='isSelected(option)')
                slot(name='option', :option='option', :search='search')
                  span.option-text(v-if='~getOptionLabel(option).indexOf("|")')
                    | {{ getOptionLabel(option).split("|")[0] }}
                    br
                    | {{ getOptionLabel(option).split("|")[1] }}
                  span.option-text(v-else) {{ getOptionLabel(option) }}
              span.dawnSelect__option.dawnSelect__option--disabled(
                v-if='!multilist && option && (option.$isLabel || option.$isDisabled)'
                :class='optionHighlight(index, option)'
              )
                slot(name='option', :option='option', :search='search')
                  span {{ getOptionLabel(option) }}
          //-  This allows us to display a message if no results are found in search.
          //-  li(v-show="showNoResults && (filteredOptions.length === 0 && search && !loading)")
          //-    span.dawnSelect__option
          //-    slot(name="noResult") No items found. Consider changing your search query.
          slot(name='afterList')
    transition(name='dawnSelect')
      .toolbar(v-if='!title' v-show='isOpen && (checkboxes || multilist)', :class='{ "hide": checkboxes && !multilist, "info": !(options[0] && options[0][groupValues]) }')
        ed-button.btn(v-if='options[0] && options[0][groupValues]' buttonClass='btn-actionbar' @click='apply') Apply
        em(v-else) No options
      .toolbar(v-else v-show='isOpen' :style='toolbarStyle')
        hr
        slot(name='toolbar')
  .dawnSelect__tags-wrap(v-show='visibleValue.length > 0' v-if='!checkboxes')
    template(v-for='option of visibleValue', @mousedown.prevent)
      slot(name='tag', :option='option', :search='search', :remove='removeElement')
        span.dawnSelect__tag
          span(v-text='getOptionLabel(option)')
          i.dawnSelect__tag-icon(aria-hidden='true', tabindex='1',
                                @keydown.enter.prevent='removeElement(option)',
                                @mousedown.prevent='removeElement(option)'
                                v-tooltip='"Remove"'
          )
</template>

<script>

import { mixin as clickaway } from 'vue-clickaway'
import multiselectMixin from './multiselectMixin'
import pointerMixin from './pointerMixin'

import EdInputTooltip from '@/core/components/edInputTooltip'
import Checkbox from '@/core/components/edCheckbox/checkbox'

export default {
  name: 'ed-select',
  mixins: [clickaway, multiselectMixin, pointerMixin],
  props: {
    decodeEntities: Boolean,
    hideOptional: Boolean,
    icon: String,
    required: {
      type: Boolean,
      default: false
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    fieldLabel: {
      type: String,
      default: ''
    },
    title: String,
    helptipHeader: String,
    helptipBody: String,
    name: {
      type: String,
      default: ''
    },
    selectLabel: {
      type: String,
      default: 'Press enter to select'
    },
    selectedLabel: {
      type: String,
      default: 'Selected'
    },
    deselectLabel: {
      type: String,
      default: 'Press enter to remove'
    },
    showLabels: {
      type: Boolean,
      default: true
    },
    limit: {
      type: Number,
      default: 99999
    },
    maxHeight: {
      type: Number,
      default: 200
    },
    limitText: {
      type: Function,
      default: count => `and ${count} more`
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    openDirection: {
      type: String,
      default: ''
    },
    showNoResults: {
      type: Boolean,
      default: true
    },
    tabindex: {
      type: Number,
      default: 0
    },
    error: Boolean,
    checkboxes: Boolean,
    multilist: Boolean,
    hidden: {
      type: Boolean,
      default: false
    },
    serverSearch: Boolean
  },
  directives: {
    focus: {
      inserted: function(el, binding) {
        if (binding.value) el.focus()
        else el.blur()
      },
      componentUpdated: function(el, binding) {
        if (binding.modifiers.lazy) {
          if (Boolean(binding.value) === Boolean(binding.oldValue)) {
            return
          }
        }
        if (binding.value) el.focus()
        else el.blur()
      }
    }
  },
  components: {
    'ed-input-tooltip': EdInputTooltip,
    'checkbox': Checkbox
  },
  created() {
    this.closeOnSelect = this.checkboxes === true ? false : this.closeOnSelect
    this.clearOnSelect = this.checkboxes === true ? false : this.clearOnSelect

    this.title && this.$on('open', this.updateBox)
  },
  watch: {
    options (newV, oldV) {
      this.title && this.updateBox()
      this.selectedPointerSet(undefined, { [this.trackBy]: (this.getValue() || {})[this.trackBy] })
      this.$nextTick(() => {
        this.$refs.list.scrollTop = this.selectedPointerPosition
      })
    }
  },
  data: function() {
    return {
      focused: false,
      toolbarStyle: {}
    }
  },
  computed: {
    selectedGroup() {
      const groups = this.options
      const options = this.groupValues

      const key = this.trackBy
      const firstSelectedKey = this.selectedValues[0] && this.selectedValues[0][key]

      return groups.find(group =>
        group[options] && group[options].find(option => option[key] === firstSelectedKey)
      ) || groups[0]
    },
    visibleValue () {
      return this.multiple || this.multilist || this.checkboxes
        ? this.internalValue.slice(0, this.limit)
        : []
    },
    deselectLabelText () {
      return this.showLabels
        ? this.deselectLabel
        : ''
    },
    selectLabelText () {
      return this.showLabels
        ? this.selectLabel
        : ''
    },
    selectedLabelText () {
      return this.showLabels
        ? this.selectedLabel
        : ''
    },
    // inputStyle () {
    //  if (this.multiple && this.value && this.value.length) {
    //    // Hide input by setting the width to 0 allowing it to receive focus
    //    return this.isOpen ? { 'width': 'auto' } : { 'width': '0', 'position': 'absolute' }
    //  }
    // },
    displayedValueStyle() {
      const extraText = ~this.currentOptionLabel.indexOf('|')
      const longText = this.currentOptionLabel.length > 20
      if (extraText || longText) {
        return {
          // fontSize: '12px',
          textOverflow: 'ellipsis'
        }
      }
      return null
    },
    displayedValueTitle() {
      const extraText = ~this.currentOptionLabel.indexOf('|')
      const longText = this.currentOptionLabel.length > 20
      if (extraText || longText) {
        return this.currentOptionLabel
      }
      return null
    },
    contentStyle () {
      return this.options.length
        ? { 'display': 'inline-block' }
        : { 'display': 'block' }
    },
    isAbove () {
      // never open above
      return false
    },
    isOver () {
      return this.openDirection === 'over'
    },
    shownValue () {
      const val = this.internalValue
      return val[0] && (this.label ? val[0][this.label] : val[0]) + ' ' +
                        (val.length > 1 ? this.limitText(val.length - 1) : '')
    }
  },
  methods: {
    apply () {
      this.$emit('apply', this.internalValue)
      this.deactivate()
    },
    selectGroup(v) {
      this.selectedGroupAfter = this.options.filter(group => v[this.groupLabel] === group[this.groupLabel])[0]
      this.options = this.options.concat(null); this.options.pop()
    },
    updateBox() {
      this.$nextTick(() => {
        this.toolbarStyle = { 'margin-top': `${this.$refs.list.clientHeight}px` }
      })
    },
    optionTooltip(option, index) {
      const shouldDisplayTooltip =
        (this.$refs.options && this.$refs.options[index] && this.$refs.options[index].children[0].offsetWidth) >
        ((this.$refs.list && this.$refs.list.offsetWidth) - 40)

      return {
        content: shouldDisplayTooltip ? this.getOptionLabel(option) : '-',
        classes: [shouldDisplayTooltip ? 'option-tooltip' : 'hide']
      }
    }
  }
}
</script>

<style scoped lang='scss'>
@import "~@/assets/sass/_variables.scss";
@import "~@/assets/sass/_form_fields.scss";

body .theme .form-group {
  margin-left: 0;
  margin-right: 0;
  padding: 0;

  em.optional {
    @include optional-label;
  }
}

// validations
.form-group {
  //@include form-field;
  &.invalid,
  &.has-error {
    .dawnSelect {
      border-width: 1px;
      @include theme {
      border-color: v(urgent-01);
      box-shadow: 0px 0px 0px 1px v(urgent-01);
      }
    }
  }
}

.control-label {

  .form-group.label-right & {
    float: right;
  }

  .form-group.label-top & {
    display: block;
    font-weight: $font-weight-extra-bold;
  }

  .form-group.tiny & {
    font-size: $font-size-base-sm;
  }
}

.select-main {
  @include theme {
  color: v(primary-05);
  }
  font-weight: $font-weight-bold;
  font-size: $font-size-small;
  margin: 0;
}

.select-secondary {
  @include theme {
  color: v(ink);
  }
  font-weight: $font-weight-normal;
  margin: 0;
}

#dawnSelect__main-wrapper {
  position: relative;
}

fieldset[disabled] .dawnSelect {
  pointer-events: none;
}
.dawnSelect__spinner {
  position: absolute;
  right: 1px;
  top: 1px;
  width: 48px;
  height: 35px;
  background: #fff;
  display: block;
}
.dawnSelect__spinner:before,
.dawnSelect__spinner:after {
  position: absolute;
  content: '';
  top: 50%;
  left: 50%;
  margin: -8px 0 0 -8px;
  width: 16px;
  height: 16px;
  border-radius: 100%;
  border-color: #41B883 transparent transparent;
  border-style: solid;
  border-width: 2px;
  box-shadow: 0 0 0 1px transparent;
}
.dawnSelect__spinner:before {
  animation: spinning 2.4s cubic-bezier(0.41, 0.26, 0.2, 0.62);
  animation-iteration-count: infinite;
}
.dawnSelect__spinner:after {
  animation: spinning 2.4s cubic-bezier(0.51, 0.09, 0.21, 0.8);
  animation-iteration-count: infinite;
}
.dawnSelect__loading-enter-active,
.dawnSelect__loading-leave-active {
  transition: opacity 0.4s ease-in-out;
  opacity: 1;
}
.dawnSelect__loading-enter,
.dawnSelect__loading-leave-active {
  opacity: 0;
}
.dawnSelect,
.dawnSelect__input,
.dawnSelect__single {
  font-family: inherit;
  font-size: $font-size-base;
  touch-action: manipulation;
}
.dawnSelect {
  @include form-field;
  box-sizing: content-box;
  display: block;
  position: relative;
  width: 100%;
  padding: .15rem 0rem;
  @include theme {
  color: v(ink);
  }
}
.dawnSelect * {
  box-sizing: border-box;
}
.dawnSelect:focus {
  outline: none;
  border: $border-width-default solid;
  @include theme {
  border-color: v(tertiary-01);
  box-shadow: 0px 0px 0px 1px v(tertiary-01);
  }
  input {
    outline:none;
  }
}
.dawnSelect.dawnSelect--multilist {
  background-image: none;
  @include theme {
  background: v(canvas);
  }
}
.dawnSelect.dawnSelect--multilist:focus {
  border: $border-width-default solid $background;
  box-shadow: none;
}
.dawnSelect--disabled {
  pointer-events: none;
  opacity: 0.6;
}
.dawnSelect--active {
  z-index: 50;
  border: $border-width-default solid;
  @include theme {
  border-color: v(tertiary-01);
  box-shadow: 0px 0px 0px 1px v(tertiary-01);
  }

  &.dawnSelect--open {
    &, &:focus {
      border: none;
      box-shadow: none;
      background: none;
    }
    .dawnSelect__tags {
      display: none;
    }
    .dawnSelect__select {
      display: none;
    }
    .dawnSelect__header-wrapper {
      background: none;
      padding: 0;
      margin-top: 0;
    }
    .toolbar {
      height: 0;
    }
  }
}

span.remove {
  float: right;
  padding: .4em;
  right: 2em;
  position: relative;
  z-index: 2;
}

.dawnSelect--active:not(.dawnSelect--above) .dawnSelect__current,
.dawnSelect--active:not(.dawnSelect--above) .dawnSelect__input,
.dawnSelect--active:not(.dawnSelect--above) .dawnSelect__tags {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
.dawnSelect--active .dawnSelect__select:before {
  transform: rotateZ(180deg);
  display: inline-block;
  top: 0;
  transition: transform .2s ease-out;
}
.dawnSelect--above.dawnSelect--active .dawnSelect__current,
.dawnSelect--above.dawnSelect--active .dawnSelect__input,
.dawnSelect--above.dawnSelect--active .dawnSelect__tags {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.dawnSelect__input,
.dawnSelect__single {
  position: relative;
  display: inline-block;
  border: none;
  box-shadow: none;
  border-radius: $border-radius;
  padding: 0 0 0 .2rem;
  width: 100%;
  transition: border 0.1s ease;
  box-sizing: border-box;
  vertical-align: top;
  @include theme {
  //background: v(canvas);
  @include placeholder {
    color: v(background);
  }
  }

  .icon-wrapper + & {
    width: calc(100% - 20px);
  }
}
.dawnSelect--multilist .dawnSelect__input {
  width: calc(100% + 3rem);
  padding-right: 3rem;
  text-overflow: ellipsis;
  cursor: pointer;
}
.icon-wrapper {
  position: relative;
  top: 1px;
  left: 3.6px;
  height: 22px;
  line-height: 22px;
}
.icon-wrapper + .dawnSelect__input {
  width: calc(100% - 20px);
  padding-left: 12px;
  line-height: 1.35;
}
.dawnSelect__tag ~ .dawnSelect__input,
.dawnSelect__tag ~ .dawnSelect__single {
  width: auto;
}
.dawnSelect__input:hover,
.dawnSelect__single:hover {
  border-color: #cfcfcf;
}
.dawnSelect__input:focus,
.dawnSelect__single:focus {
  border-color: #a8a8a8;
  outline: none;
}
.dawnSelect__single {
  padding-left: 6px;
  //margin-bottom: 8px;
  margin-top: 1px;
  margin-left: 6px;
}
.dawnSelect__tags-wrap {
  display: inline;
  position: relative;
  top: 8px;
}
.dawnSelect__tags {
  display: block;
  padding: .25rem 2.5rem .22rem .6rem;
  @include theme {
  background: v(canvas);
  }
}
.dawnSelect__tag {
  font-size: $font-size-base-sm;
  position: relative;
  display: inline-block;
  padding: 3px 26px 3px 10px;
  border-radius: 10px;
  margin-right: 10px;
  @include theme {
  color: v(ink);
  border: 1px solid v(border);
  }
  line-height: 1;
  background: none;
  margin-bottom: 2px;
  white-space: nowrap;
  overflow: hidden;
  max-width: 100%;
  text-overflow: ellipsis;
  cursor: default;
}
.dawnSelect__tag:hover {
  @include theme {
  border-color: v(ink);
  }
}
.dawnSelect__tag-icon {
  cursor: pointer;
  margin-left: 7px;
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  //font-weight: 700;
  font-style: initial;
  width: 22px;
  text-align: center;
  line-height: 1.3em;
  //transition: all 0.2s ease;
  //border-radius: 5px;
  @include theme {
  color: v(primary-04);
  }
  @include fa-icon($fa-var-times-circle);
  font-size: $font-size-base;

}
.dawnSelect__tag-icon:after {
  //content: "×";
  //color: #266d4d;
  //font-size: $font-size-base;
}
.dawnSelect__tag-icon:focus,
.dawnSelect__tag-icon:hover {
  &:before {
    @include theme {
    color: black;
    }
  }
}
.dawnSelect__tag-icon:focus:after,
.dawnSelect__tag-icon:hover:after {
  color: white;
}
.dawnSelect__current {
  line-height: 16px;
  min-height: 40px;
  box-sizing: border-box;
  display: block;
  overflow: hidden;
  padding: 8px 12px 0;
  padding-right: 30px;
  white-space: nowrap;
  margin: 0;
  text-decoration: none;
  border-radius: 5px;
  border: 1px solid #E8E8E8;
  cursor: pointer;
}
.form-group.inline .dawnSelect__select {
  line-height: 90%;
}
.dawnSelect__select {
  //line-height: 90%;
  display: block;
  position: absolute;
  box-sizing: border-box;
  width: 40px;
  height: 90%;
  right: 1px;
  top: 1px;
  padding: 4px 8px;
  margin: 0;
  text-decoration: none;
  text-align: center;
  cursor: pointer;
  transition: transform 0.2s ease;
}
.dawnSelect__select:before {
  position: relative;
  right: 0;
  top: 0;
  margin-top: 4px;
  border-style: solid;
  border-width: 5px 5px 0 5px;
  @include theme {
  color: v(border);
  border-color: v(border) transparent transparent transparent;
  }
  content: '';
  transform: rotateZ(0deg);
  display: inline-block;
  transition: transform .2s ease-out;

  .form-group.loading & {
    display: none;
  }
}
.dawnSelect__select:hover {
  &:before {
    @include theme {
    color: v(secondary-01);
    border-color: v(secondary-01) transparent transparent transparent;
    }
  }
}
.dawnSelect--multilist .dawnSelect__select:before {
  z-index: 1;
  pointer-events: none;
}
.dawnSelect__placeholder {
  color: #ADADAD;
  display: inline-block;
  margin-bottom: 10px;
  padding-top: 2px;
}
.dawnSelect--active .dawnSelect__placeholder {
  display: none;
}
.dawnSelect__header-wrapper {
  position: relative;
  z-index: 51;
  margin-top: -24px;
  padding: 0 10px;
  @include theme {
  background: v(canvas);
  }

  > label {
    padding-left: 3px;
  }

  &.empty {
    display: none;
  }

  padding-bottom: 10px;

  .list-search.list-search {

  }
}
.toolbar {
  padding: 0 10px;
  border: 1px solid;
  border-top: none;
  @include theme {
  background: v(canvas);
  border-color: v(background);
  }
  position: relative;
  z-index: 3;

  hr {
    @include theme {
    background: v(background);
    color: v(background);
    border-color: v(background);
    }
    margin: 0 -4px 7px -4px;
  }

  &.info {
    margin-top: -20px;
    color: #ccc;
    z-index: 99;
    padding-bottom: 5px;
  }
}
.dawnSelect__content-wrapper {
  position: absolute;
  display: block;
  @include theme {
  background: v(canvas);
  border-color: v(background);
  }
  width: 100%;
  max-height: 240px;
  overflow-y: auto;
  border: $border-width-default solid;
  z-index: 50;
  -webkit-overflow-scrolling: touch;
  //margin-top: 4px;
  overflow-x: hidden;
}
.header-wrapper {
  padding: 7px 8px 10px;
  font-weight: 700;
  font-size: $font-size-small;
  //transform: rotate(.03deg); //soften font a bit
  //margin-top: 7px;
}

.dawnSelect--multilist > .dawnSelect__content-wrapper {
  //position: static;
  position: relative;
  border: none;
}

.dawnSelect__content-wrapper::-webkit-scrollbar-track {
  border-radius: 10px;
  background-color: transparent;
  padding-right: 2px;
}
.dawnSelect__content-wrapper::-webkit-scrollbar {
  width: 6px;
  background-color: transparent;
}
.dawnSelect__content-wrapper::-webkit-scrollbar-thumb{
  border-radius: 10px;
  @include theme {
  background-color: v(background);
  }
}
.dawnSelect__content {
  list-style: none;
  display: inline-block;
  padding: 0;
  margin: 0;
  min-width: 100%;
  vertical-align: top;
  width: 100%;
}
.dawnSelect--above .dawnSelect__content-wrapper {
  bottom: 100%;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  border-bottom: none;
  border-top: 1px solid #E8E8E8;
}
.dawnSelect--above.dawnSelect--multilist .dawnSelect__content-wrapper {
  bottom: auto;
  border-radius: 0;
  border-top: 0;
}
.dawnSelect--over {
  .dawnSelect__content-wrapper {
    margin-top: -5px;
    margin-left: -4px;
    width: calc(100% + 7px);
    top: 0%;
    bottom: auto;
    border-radius: 5px;
    border: 1px solid #E8E8E8;

    &.empty {
      //display: none;
      border: 0 none;
    }
  }
}

.dawnSelect__content::webkit-scrollbar {
  display: none;
}
.dawnSelect__element {
  display: block;
  // font-size: $font-size-small;
  font-size: $font-size-base;

  .filter-views .dawnSelect__content-wrapper & {
    .dawnSelect__option {
      padding-left: 12px;
      padding-right: 12px;
    }

    margin-right: -6px;
    &:hover {
      @include theme {
      background-color: v(background-light);
      //border-bottom: 1px solid v(background-light);
      box-shadow: 0 1px 3px darken(v(background), 10%);
      }
    }
  }
}

.dawnSelect__element:hover {
  @include theme {
  background: v(background-light);
  }
}
.dawnSelect__option {
  text-overflow: ellipsis;
  overflow: hidden;
  display: block;
  padding: 8px 16px;
  min-height: 24px;
  line-height: 16px;
  text-decoration: none;
  text-transform: none;
  vertical-align: middle;
  position: relative;
  cursor: pointer;
  white-space: nowrap;
  // font-size: $font-size-small;
  font-size: $font-size-base;
  .dawnSelect--multilist > .dawnSelect__content-wrapper & {
    min-height: 16px;
    line-height: 14px;
    padding: 3px 18px;
    font-size: $font-size-base-sm;

    &:hover, &.multiselect__option--selected {
      cursor: pointer;
      @include theme {
      background-color: lighten(v(secondary-04), 7%);
      }
    }
  }
  .dawn-checkbox + .option-text {
    display: inline-block;
    width: 80%;
    overflow: hidden;
    text-overflow: ellipsis;
    vertical-align: top;
  }

  .dawn-checkbox {
    display: inline-block;
    pointer-events: none;
  }

  >>> .action-icon {
    font-size: 1.1em;
    line-height: 1.5em;
    @include theme {
    color: v(border);
    &:hover {
      color: v(ink);
    }
    }
  }

  >>> .option-icon-hover {
    visibility: hidden;
  }
  &:hover >>> .option-icon-hover {
    visibility: visible;
  }
}
.dawnSelect__option:after {
  top: 0;
  right: 0;
  position: absolute;
  line-height: 40px;
  padding-right: 12px;
  padding-left: 20px;
}
.dawnSelect__option--highlight,
.multiselect__option--highlight {
  outline: none;
  // margin: -1px;
  z-index: 99;
  @include theme {
  // border: 1px dashed v(ink);
  background: v(background-light);
  }
}
.dawnSelect__option--highlight:after,
.multiselect__option--highlight:after {
  // content: attr(data-select);
  font-size: 12px;
  font-style: italic;
  margin-top: -4px;
  // background: #41B883;
  @include theme {
  color: v(ink);
  }
}
.dawnSelect__option--selected,
.dawnSelect__option.multiselect__option--selected {
  @include theme {
  background-color: v(secondary-04);
  }
  // color: #35495E;
  // font-weight: bold;
}
.dawnSelect__option--selected:after {
  content: attr(data-selected);
  color: silver;
}
.dawnSelect__option--selected.dawnSelect__option--highlight {
  background: #FF6A6A;
  color: #fff;
}
.dawnSelect__option--selected.dawnSelect__option--highlight:after {
  background: #FF6A6A;
  content: attr(data-deselect);
  color: #fff;
}
.dawnSelect--disabled, .dawnSelect--disabled .dawnSelect__tags, .dawnSelect--disabled .dawnSelect__input {
  background: #ededed;
  pointer-events: none;
  @include theme {
  background-image: none;
  }
}
.dawnSelect--disabled .dawnSelect__current,
.dawnSelect--disabled .dawnSelect__select {
  background: #ededed;
  color: #a6a6a6;
}
.dawnSelect__option--disabled {
  background: #ededed;
  color: #a6a6a6;
  cursor: text;
  pointer-events: none;
}
.dawnSelect__option--disabled.dawnSelect__option--highlight {
  background: #dedede !important;
}
.dawnSelect-enter-active,
.dawnSelect-leave-active {
  transition: all 0.15s ease;
}
.dawnSelect-enter,
.dawnSelect-leave-active {
  opacity: 0;
}
.dawnSelect__strong {
  margin-bottom: 8px;
  line-height: 20px;
  display: inline-block;
  vertical-align: top;
}
*[dir="rtl"] .dawnSelect {
    text-align: right;
}
*[dir="rtl"] .dawnSelect__select {
    right: auto;
    left: 1px;
}
*[dir="rtl"] .dawnSelect__tags {
    padding: 8px 8px 0px 40px;
}
*[dir="rtl"] .dawnSelect__content {
    text-align: right;
}
*[dir="rtl"] .dawnSelect__option:after {
    right: auto;
    left: 0;
}
*[dir="rtl"] .dawnSelect__clear {
    right: auto;
    left: 12px;
}
*[dir="rtl"] .dawnSelect__spinner {
    right: auto;
    left: 1px;
}
@keyframes spinning {
  from { transform:rotate(0) }
  to { transform:rotate(2turn) }
}

.dawnSelect__content-table-wrapper {
  display: table;
  width: 100%;
}
.dawnSelect__content-table-row-wrapper {
  display: table-row;
}

.dawnSelect__content-table-body-wrapper {
  display: table-row-group;
}
.dawnSelect__content-table-image-wrapper {
  width: 70px;
  display: table-cell;
  height: 60px;
  padding: 0px 0px 0px 10px;
}

.dawnSelect__content-table-image-wrapper img {
  width: 100%;
}
.dawnSelect__content-table-content-wrapper {
  vertical-align: top;
  display: table-cell;
  padding: 0px 10px;
}

//
.form-group.inline.filter-views {
  .dawnSelect {
    min-width: 230px;
    min-height: 24px;
  }
  .dawnSelect--active.dawnSelect--over {
    border: 0;
    margin: 1px;
    box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.45);
  }
  .dawnSelect__single {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    max-width: 160px;
  }
  .dawnSelect__content-wrapper,
  .dawnSelect__header-wrapper,
  .toolbar {
    position: absolute;
    line-height: 2.2em;

    >>> label {
      line-height: 1em;
      display: block;
    }
    >>> .form-group.small.box {
      width: 140px;
    }

    box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.45);
  }
  .dawnSelect__header-wrapper {
    margin-left: -4px;
    width: calc(100% + 7px);
    margin-top: -34px;
    padding-top: 5px;
    @include theme {
    border: 1px solid v(background-light);
    border-bottom: none;
    }
    border-radius: 0;
    z-index: 50;
    display: none;
  }
  .toolbar {
    width: 100%;
    z-index: 51;
    top: 32px;
    //margin-left: -4px;
    //width: calc(100% + 7px);
    //padding-top: 10px;
    @include theme {
    border: 1px solid v(background-light);
    border-top: 0;
    border-bottom: none;
    }
    border-radius: 0;
    //box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.35);

    & >>> .btn {
      margin-top: 0;
      margin-bottom: 0;
    }
    padding-bottom: 15px;
  }

  .dawnSelect__header-wrapper, {
    //padding-bottom: 5px;
    padding-bottom: 0px;
    .label-title {
      text-transform: uppercase;
    }
  }
  .dawnSelect__content-wrapper {
    //margin-top: 30px;
    margin-top: 32px;
    padding-top: 1px;
    border-radius: 0;
    border-bottom: 0;
    margin-left: 0;
    width: 100%;
  }
}

// Inline block
.form-group.inline-block {
  display: inline-block;

  .dawnSelect {
    padding: 1px 0;
  }
  &.inline .dawnSelect {
    padding: 4px 0;
    .dawnSelect__select {
      line-height: inherit;
    }
  }

  &, > label {
    vertical-align: top;
  }
}

// Small inline
.form-group.inline {
  display: inline-block;

  &.small .dawnSelect {
    border-top: none;
    border-right: none;
    border-left: none;
    border-radius: 0;

    .dawnSelect__tags {
      @include theme {
      background: v(canvas);
      }
    }
  }
  &.tiny .dawnSelect {
    width: 90px;
    margin-left: .5em;
    margin-right: .5em;

    .dawnSelect__select {
      width: 20px;
      padding-right: 0;
      &:before {
        border-width: 4px 4px 0 4px;
      }
    }
    .dawnSelect__tags {
      padding-left: 0;
      padding-right: 2rem;
    }
    .dawnSelect__input,
    .dawnSelect__option {
      font-size: $font-size-base-sm;
    }
  }
  &.stretch {
    display: block;
    .dawnSelect {
      width: 100%;
    }
  }
  .dawnSelect {
    padding-top: 0px;
    padding-bottom: 0px;
    width: auto;
    display: inline-block;
    @include theme {
    border-color: v(background);
    }
    &:not(.inline-block) & {
      border-radius: 3em;
      background: transparent;
    }

    .dawnSelect__tags {
      padding-top: 1px;
      padding-bottom: 1px;
      background: transparent;
      input.dawnSelect__input {
        background: transparent;
        height: 22px;
        line-height: 22px;
      }
    }
  }
}

// Widget Select Styles
.widget-select {
  .dawnSelect {
    @include theme {
    border-color: v(ink);
    }
    border-radius: 3em;
    background: transparent;
  }

  .dawnSelect__tags {
    background: transparent;
    input.dawnSelect__input {
      background: transparent;
      color: $canvas;
      @include placeholder {
        color: $canvas;
      }
    }
  }

  .dawnSelect__select {
    &:before {
      @include theme {
      color: v(border);
      border-color: v(border) transparent transparent transparent;
      }
    }
  }

}

</style>



// WEBPACK FOOTER //
// src/core/components/edSelect/index.vue